import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const statsVariants = {
    hidden: { scale: 0 },
    visible: {
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="about-page section" id="about" ref={ref}>
      <div className="container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.div className="section__header" variants={itemVariants}>
            <h2 className="section__title">About Me</h2>
            <p className="section__subtitle">Get to know me better</p>
          </motion.div>

          <div className="about__content">
            <motion.div className="about__text" variants={itemVariants}>
              <div className="about__description">
                <p>
                  I'm a passionate <span className="highlight"> software engineer</span> with 
                  over 3 years of experience building scalable web applications and innovative solutions. 
                  My journey in technology started with a curiosity about how things work, which led me 
                  to pursue Computer Science and fall in love with programming.
                </p>
                <p>
                  I specialize in <span className="highlight">backend engineering.</span> 
                  I'm particularly passionate about 
                  creating robust and scalable applications that solve real-world problems and 
                  meet user expectations.
                </p>
                <p>
                  When I'm not coding, you can find me managing my football club on FM,
                  lifting weights at the gym, or enjoying outdoor activities. 
                  I believe in <span className="highlight">continuous learning</span> and staying 
                  up-to-date with the latest industry trends and best practices.
                </p>
              </div>
            </motion.div>

          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default About;